import { browserHistory } from 'react-router';
import PlansActionType from '../../common/PlansActionType';
import MyAccountActionType from '../../common/MyAccountActionType';
import RestService from '../../services/RestService';

const callback = (dispatch) => {
  dispatch({ type: MyAccountActionType.RESET_ALL });
  dispatch({ type: PlansActionType.RESET_ALL });
  browserHistory.push('/login');
};

const logout = (dispatch, error) => {
  // eslint-disable-next-line no-console
  console.error(`Called: logout(dispatch, ${error})`);
  RestService.post('/api/customer-self-management/rest/customerSelfManagement/access/logout')
    .then(callback(dispatch));
};

const submitLogout = () => dispatch =>
  logout(dispatch, 'Customer initiated logout');

export default {
  logout,
  submitLogout
};



/** WEBPACK FOOTER **
 ** ./src/redux/actions/LogoutAction.js
 **/